<template>
  <DashboardHeader title="Live Lessons">
    <CrudTables :tables="tables"></CrudTables>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import CrudTables from "@/components/myLibrary/CrudTables.vue";

import axios from "@/plugins/axios";
export default {
  components: {
    DashboardHeader,
    CrudTables
  },

  data() {
    return {
      tables: [
        {
          text: "Live Lessons",
          value: "live_lessons",
          alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Grades",
          value: "grades",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        {
          text: "Classes",
          value: "classes",
          alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15]
        },

        {
          text: "Subjects",
          value: "subjects",
          alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        },
        // {
        //   text: "Topics",
        //   value: "topics",
        //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        // },
        // {
        //   text: "Slides",
        //   value: "slides",
        //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        // },
        // {
        //   text: "Questions",
        //   value: "questions",
        //   alevel: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        // }
      ]
    };
  }
};
</script>
